// src/components/KullaniciYonetimi.js

import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Button, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton, Tooltip, CircularProgress, Chip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { db, functions } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import UserFormModal from './UserFormModal';

const KullaniciYonetimi = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const fetchUsers = async () => {
    try {
      const usersCollectionRef = collection(db, 'users');
      const querySnapshot = await getDocs(usersCollectionRef);
      const usersList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setUsers(usersList);
    } catch (error) {
      console.error("Kullanıcıları çekerken hata oluştu: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchUsers();
  }, []);

  const handleAddNewUser = () => {
    setEditingUser(null);
    setIsModalOpen(true);
  };

  const handleSaveUser = async (userData) => {
    if (editingUser) {
      const updateUser = httpsCallable(functions, 'updateUser');
      try {
        await updateUser({ userId: editingUser.id, ...userData });
        alert('Kullanıcı başarıyla güncellendi!');
        await fetchUsers();
      } catch (error) {
        console.error("Cloud function hatası:", error);
        throw new Error(error.message);
      }
    } else {
      const createUser = httpsCallable(functions, 'createNewUser');
      try {
        await createUser(userData);
        alert('Yeni kullanıcı başarıyla oluşturuldu!');
        await fetchUsers();
      } catch (error) {
        console.error("Cloud function hatası:", error);
        throw new Error(error.message);
      }
    }
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setIsModalOpen(true);
  };

  const handleDeleteUser = async (user) => {
    if (!window.confirm(`"${user.username || user.email}" kullanıcısını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.`)) {
      return;
    }

    const deleteUserFn = httpsCallable(functions, 'deleteUser');
    try {
      await deleteUserFn({ userId: user.id });
      alert('Kullanıcı başarıyla silindi!');
      await fetchUsers();
    } catch (error) {
      console.error("Kullanıcı silme hatası:", error);
      alert(`Hata: ${error.message}`);
    }
  };

  const getRoleColor = (role) => {
    const colors = {
      'Genel Müdür': 'error',
      'Müdür': 'warning',
      'Koordinatör': 'info',
      'Usta': 'success'
    };
    return colors[role] || 'default';
  };

  return (
    <>
      <UserFormModal
        isOpen={isModalOpen}
        onClose={() => { setIsModalOpen(false); setEditingUser(null); }}
        onSave={handleSaveUser}
        userToEdit={editingUser}
      />
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" component="h2">Kullanıcı Yönetimi</Typography>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleAddNewUser}>Yeni Kullanıcı Ekle</Button>
        </Box>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Kullanıcı Adı</TableCell>
                  <TableCell>E-posta</TableCell>
                  <TableCell>Rol</TableCell>
                  <TableCell align="right">İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4 }}><CircularProgress size={24} /><Typography sx={{ ml: 2, display: 'inline' }}>Yükleniyor...</Typography></TableCell></TableRow>
                ) : users.length === 0 ? (
                  <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4 }}><Typography color="text.secondary">Henüz kayıtlı kullanıcı yok.</Typography></TableCell></TableRow>
                ) : (
                  users.map((user) => (
                    <TableRow hover key={user.id}>
                      <TableCell>{user.username || 'Belirtilmemiş'}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell><Chip label={user.role} color={getRoleColor(user.role)} size="small" /></TableCell>
                      <TableCell align="right">
                        <Tooltip title="Düzenle"><IconButton size="small" onClick={() => handleEditUser(user)}><EditIcon fontSize="small" /></IconButton></Tooltip>
                        <Tooltip title="Sil"><IconButton size="small" color="error" onClick={() => handleDeleteUser(user)}><DeleteIcon fontSize="small" /></IconButton></Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>
  );
};

export default KullaniciYonetimi;